<template>
	<div class="product-meta w-full">
		<div class="border-b border-gray-dark">
			<div
				class="-mb-px flex space-x-6 overflow-x-auto"
				role="tablist"
				:aria-label="$t('Product information tabs')"
				@keydown="handleKeydown"
			>
				<button
					v-for="tab in tabs"
					:id="getTabId(tab.value)"
					:key="tab.name"
					type="button"
					role="tab"
					:aria-selected="currentTabHash === tab.value"
					:aria-controls="
						currentTabHash === tab.value ? getTabpanelId(tab.value) : undefined
					"
					:tabindex="getTabindex(tab.value)"
					:class="[
						currentTabHash === tab.value
							? 'border-secondary text-primary'
							: 'border-transparent text-primary hover:border-gray-darker hover:text-primary',
						'cursor-pointer whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'
					]"
					@click="() => changeTab(tab.value)"
				>
					{{ tab.name }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useTablistKeyboard } from "~/layers/base/composables/useTablistKeyboard";
import { getTabId, getTabpanelId } from "~/utils/product/productTabIds";

interface Props {
	tabs: { name: string; value: string }[];
	changeTab: (value: string) => string;
	currentTabHash: string;
}

const props = defineProps<Props>();

const { getTabindex, handleKeydown } = useTablistKeyboard({
	tabs: () => props.tabs,
	selected: () => props.currentTabHash,
	onSelect: (value) => props.changeTab(value)
});
</script>
